module.exports = __webpack_public_path__ + "static/2009-header-dbf19a8234eb449565574ba614bc0aea.jpg";